export const mitrexProposal = {
  project_info : {
    name: {
      label: 'Project Name',
      f_component: 'VTextField',
      d_component: null,
      bind: {
        disabled: true
      },
      value: 'Fram & Slokker'
    },
    address: {
      label: 'Project Address',
      f_component: 'VTextField',
      d_component: null,
      bind: {
        disabled: true
      },
      value: '55 Port Street, Mississauga, ON'
    },
    sales_person: {
      label: 'Sales Person',
      f_component: 'VTextField',
      d_component: null,
      bind: {
        disabled: true
      },
      value: {
        'From': 'Kevin Monsour',
        'Phone': '+1 888.222.222',
        'Mobile': '(416)999-999',
        'Email': 'email@email.com',
        'Estimator': 'Neda Emam'
      }
    },
    contact: {
      label: 'Proposal Contact',
      f_component: 'VSelect',
      d_component: 'VContactTable',
      bind: {
        itemText: 'Name',
        options: [
          {
            'To': 'Contact 1',
            'Name': '',
            'Phone': '416.222.222',
            'Email': 'email@email.com',
            'Quote No.': 192238
          },
          {
            'To': 'Contact 2',
            'Name': '',
            'Phone': '416.222.221',
            'Email': 'email@email.com',
            'Quote No.': 192238
          },
        ]
      },
      value: {
        'To': '',
        'Name': '',
        'Phone': '',
        'Email': '',
        'Quote No.': ''
      }
    },
    date: {
      label: 'Proposal Date',
      f_component: 'VDatePicker',
      d_component: null,
      value: null
    },
    cover_photo: {
      label: 'Proposal Cover Photo',
      f_component: 'VDropZone',
      d_component: null,
      value: {
        file: '',
        name: '',
        url: ''
      }
    },
    pricing: {
      rfq_id: null,
      has_mpa_price: true,
      has_dpa_price: true
    }
  },
  proposal_info: [
    {
      id: 'supply_install',
      label: 'Supply and/or Install',
      f_component: 'VMultiCheckbox',
      d_component: 'custom',
      bind: {
        options: ['supply', 'install']
      },
      value: ['supply', 'install']
    },
    {
      id: 'products',
      label: 'Products',
      f_component: 'VMultiCheckbox',
      d_component: 'custom',
      bind: {
        options: ['SolaRail&#153', 'Solar Cladding', 'Solar Curtain Wall', 'Solar Skylight', 'Cladify']
      },
      value: ['SolaRail&#153', 'Solar Cladding']
    },
    {
      id: 'quote_details',
      label: 'Quote Details',
      f_component: 'VRichText',
      d_component: 'VRichTextRenderer',
      bind: {
        placeholder: 'Enter quote details'
      },
      value: `<span>Our Scope of Work is as follows:</span>
              <ul>
                <li>{TOTAL_SOLAR_CLADDING_SQFT} SQFT and {TOTAL_SOLAR_CLADDING_LFT} LFT of Mitrex Solar Cladding</li>
                <li>{TOTAL_RAILING_LFT} LFT of Mitrex Solar Railing</li>
                <li>{TOTAL_CLADDING_SQFT} SQFT and {TOTAL_CLADDING_LFT} LFT of regular cladding</li>
              </ul>`
    },
    {
      id: 'documents',
      label: 'Documents',
      f_component: 'VDynamicList',
      d_component: 'VDocTable',
      bind: {
        rowTemplate: [
          { 
            label: 'name',
            component: 'VTextField',
            bind: {},
            default: ''
          },
          { 
            label: 'received_on',
            component: 'VDatepicker',
            bind: {},
            default: null 
          },
          {
            label: 'details',
            component: 'VTextField',
            bind: {
              placeholder: "Enter other details for document"
            },
            default: ''
          }
        ],
        isColumn: true
      },
      value: []
    },
    {
      id: 'document_details',
      label: 'Document Details',
      f_component: 'VRichText',
      d_component: 'VRichTextRenderer',
      bind: {
        placeholder: 'Enter document details'
      },
      value: ''
    },
    {
      id: 'system',
      label: 'System',
      f_component: 'VRichText',
      d_component: 'VRichTextRenderer',
      value: `<ul>
                <li><mark>Rainscreen Cladding System</mark>
                  <ul>
                    {INSTALLATION_METHODS_LIST}
                  </ul>
                </li>
              </ul>`
    },
    {
      id: 'pmf',
      label: 'Products, Materials & Finishes',
      f_component: 'VRichText',
      d_component: 'VRichTextRenderer',
      value: '{PMF}'
    },
    {
      id: 'installation_materials',
      label: 'Installation Materials Components/ Accessories',
      f_component: 'VRichText',
      d_component: 'VRichTextRenderer',
      value: `<ul>
                <li>Flashing:
                  <ul>
                    <li><mark>24-gauge single side prepainted - galvanized steel cold bended sheets</mark></li>
                  </ul>
                </li>
                <li>Aluminum Profiles / Trims:
                  <ul>
                    <li><mark>1mm 3003 prefabricated aluminum sheet/ paint as per standard PPG colors</mark></li>
                  </ul>
                </li>
                <li>Air/Water Barrier:
                  <ul>
                    <li><mark>Dorken DELTA-STRATUS SA Self-Adhered Water-Resistive Barrier & Air Barrier with High UV Resistance</mark></li>
                    <li><mark>Henry Blueskin VP160 -Self-Adhered Water Resistive Air Barrier</mark></li>
                  </ul>
                </li>
                <li>Caulking: 
                  <ul>
                    <li><mark>DOWSIL contractors weatherproofing / colors as per manufacturer</mark></li>
                  </ul>
                </li>
                <li>Insulation: 
                  <ul>
                    <li><mark>2" Rockwool Cavityrock - Exterior Insulation for Cavity Wall and Rainscreen Applications</mark></li>
                    <li><mark>2" Rockwool Comfortboard 80 - Thermal Insulated Sheathing</mark></li>
                  </ul>
                </li>
                <li>System subframing:
                  <ul>
                    <li><mark>Adjustable thermally broken bracket system - max adjustability 2"</mark></li>
                    <li><mark>16 gauge galvanised steel vertical L-Angles - max system depth 4"</mark></li>
                    <li><mark>1" Interlocking channel system extrusion based on Alloy 6063 T6, Mill finished</mark></li>
                  </ul>
                </li>
                <li>Electrical Components:
                  <ul>
                    <li><mark>Inverter as required</mark></li>
                    <li><mark>Connection cables and conduits as required</mark></li>
                  </ul>
                </li>
              </ul>
              <small>**General detail - Installation materials. System details and wall assembly components will be finalized during the shop drawing phase.</small>`
    },
    {
      id: 'project_scope',
      label: 'Inclusions',
      f_component: 'VRichText',
      d_component: 'VRichTextRenderer',
      value: `<strong>Solar Cladding</strong>
              <ul>
                <li><mark>Supply and install</mark> of Mitrex Solar Facades</mark> and associate mounting accessories as per highlighted areas on drawings.</li>
                <li>{INSTALLATION_METHODS_TEXT} and associated fastening accessories.</li>
                <li><mark>Supply and install</mark> of insulation 3" Rockwool Cavityrock - Exterior Insulation for Cavity Wall and Rainscreen Applications or equal product.</li>
                <li><mark>Supply and install</mark> of AWB Dorken DELTA-STRATUS SA Self-Adhered Water-Resistive Barrier & Air Barrier with High UV Resistance or equal product.</li>
                <li>Flashing at head and jamb of windows where required - 24-gauge single side prepainted - galvanized steel cold bended sheets.</li>
                <li><mark>Supply and install</mark> of all electrical wiring and components in accordance with the delivered drawings.</li>
                <li>Supply of the necessary conduits.</li>
                <li>Field applied caulking/sealant with backer rod between Mitrex panels/panel to panel joints only. </li>
                <li>Prefabricated panel system - Cut-to-size fabrication will be fabricated in the factory.</li>
                <li>The assumed substrate for the mounting panel's system is metal stud. For cast concrete/ concrete block substrate an ad applies.</li>
                <li>Shop drawings, engineering - All engineering for panel systems, including calculations stamped by a professional engineer in the <mark>City of Toronto</mark>.</li>
                <li>Delivery and packing, crating <mark>FOB to job site</mark>.</li>
                <li>All work to be performed during regular working hours with non-union labor forces. Any additional work to be billed based on time and material basis at $145/hour.</li>
                <li>All work to be performed uninterrupted and based on safe work practice.</li>
                <li>In the event of conflicting/missing drawings / information, a scope review / agreement will be required before proceeding with an order. We will be pleased to finalize our price (if necessary) once scope is agreed upon.</li>
                <li>Based on one production run. If additional production is required due to customer phasing, an addition applies and will result in price being re-estimated.</li>
                <li>Based on one mobilization. If additional mobilizations are required due to customer phasing, an addition applies.</li>
                <li>If needed, spandrel glass provided will be added to the curtain wall solution provided by others. Integration instructions and modification details to the unit will be supplied by Mitrex.</li>
              </ul>
              <strong>Solar Railing</strong>
              <ul>
                <li><mark>Supply and install</mark> of Mitrex Solar Railing and associate mounting accessories as per highlighted areas on drawings and all associated fastening components.</li>
                <li><mark>Supply and Install</mark> of all electrical wiring in accordance with the delivered drawings.</li>
                <li>Supply of all necessary conduits.</li>
                <li>Shop drawings, engineering - All engineering for systems, including calculations stamped by a professional engineer in the <mark>City of Toronto</mark>.</li>
                <li>Delivery and packing, crating <mark>FOB to job site</mark>.</li>
                <li>Existing work to be structurally sound and able to accept fastening systems.</li>
                <li>All work to be performed during regular working hours with non-union labor forces. Any additional work to be billed based on time and material basis at $145/hour.</li>
                <li>All work to be performed uninterrupted and based on safe work practice.</li>
                <li>In the event of conflicting/missing drawings / information, a scope review / agreement will be required before proceeding with an order. We will be pleased to finalize our price (if necessary) once scope is agreed upon.</li>
                <li>Based on one production run. If additional production is required due to customer phasing, an addition applies and will result in price being re-estimated.</li>
                <li>Based on one mobilization. If additional mobilizations are required due to customer phasing, an addition applies.</li>
              </ul>`
    },
    {
      id: 'project_exclusions',
      label: 'Exclusions',
      f_component: 'VRichText',
      d_component: 'VRichTextRenderer',
      value: `<strong>Solar Cladding</strong>
              <ul>
                <li>Any and all areas that are not highlighted on drawings. This proposal is based on Sq.Ft, any changes in material take off will result in re-estimating the project.</li>
                <li>Cutting and patching of slab edges.</li>
                <li>Window sill flashing.</li>
                <li>Thru-wall or counter flashings.</li>
                <li>Roofing membrane. Any cap flashing at interface with roofing and structure.</li>
                <li>Spray or liquid applied air or air/vapour barrier.</li> 
                <li>Spray applied insulation systems.</li>
                <li>Any type of air/vapour barrier tie-ins around any opening such as windows, doors, louvers and penetrations as this is the responsibility of the trade installing such item(s).</li>
                <li>Installation of wood backing or blocking.</li>
                <li>All hoarding permits and public protection not included.</li>
                <li>Installation of any exterior lighting, and all other electrical components. Removal of any items. </li>
                <li>Supply and installation of any signage and provision to accommodate the same.</li>
                <li>Painted fasteners.</li>
                <li>Attic stock.</li>
                <li>Perimeter foaming.</li>
                <li>Performance mock-up.</li>
                <li>Smoke seal.</li>
                <li>Acoustic sealants.</li>
                <li>Provisions for acoustic insulation and sound dampening materials, either floor-to-floor or room-to-room.</li>
                <li>Supply of exhaust boxes and vents. Connection of any mechanical components.</li>
                <li>Any / all Structural anchors and fasteners.</li>
                <li>Substrate framing, structural supports and metal stud framing, structural steel framing, structural steel studs, sheathing products (DensGlass, plywood, etc.), top parapet, top parapet flashing. System depth passing 8" will be considered as a structural component.</li>
                <li>Costs associated with use of the material hoist and crane.</li>
                <li>Construction of or supply of spray racks, chambers, water supply or any other material for field testing.</li>
                <li>Any permits, licenses and certificates.</li>
                <li>Final cleaning of panel, including removal of stickers/labels, and protective films.</li>
                <li>No penetration option available on Mitrex panel system for signage, lighting, etc.</li>
                <li>Caulking and backer rod around adjacent materials, and panel return to window, doors, louvers and penetrations.</li>
              </ul>
              <strong>Solar Railing</strong>
              <ul>
                <li>Any and all areas that are not highlighted on drawings. This proposal is based on LF, any changes in material take off will result in re-estimating the project.</li>
                <li>All hoarding permits and public protection not included.</li>
                <li>Installation of any exterior lighting, and all other electrical components. Removal of any items.</li>
                <li>Supply and installation of any signage and provision to accommodate the same.</li>
                <li>Painted fasteners.</li>
                <li>Attic stock.</li>
                <li>Performance mock-up.</li>
                <li>Costs associated with use of the material hoist and crane.</li>
                <li>Any permits, licenses and certificates.</li>
                <li>Final cleaning of railing, including removal of stickers/labels, and protective films.</li>
                <li>No penetration option available on Mitrex system for signage, lighting, etc.</li>
              </ul>`
    },
    {
      id: 'proposal_validity',
      label: 'Proposal Validity',
      f_component: 'VRichText',
      d_component: 'VRichTextRenderer',
      value: 'The proposal is valid for <mark>thirty (30) days</mark>.'
    }
  ],
  proposal_content: [
    {
      id: 'material_and_installation',
      name: 'Material Selection and Installation Details',
      type: 'static',
      visible: true,
      subsections: [
        {
          label: 'Materials',
          id: 'materials',
          f_component: 'VDynamicList',
          d_component: 'DynamicMaterials',
          f_bind: { hasAddButton: true },
          d_bind: { class: 'break-after' },
          template: [
            {
              label: 'image',
              component: 'VFileUpload',
              tag: 'img',
              bind: {
                hasName: true
              },
              default: {
                file: '',
                name: '',
                url: ''
              }
            },
            {
              label: 'material',
              component: 'VTextField',
              tag: 'h3',
              bind: {
                placeholder: 'Material'
              },
              default: ''
            },
            {
              label: 'text',
              component: 'VTextField',
              tag: 'p',
              bind: {
                placeholder: 'Material description',
                counter: true,
                counterValue: 160
              },
              default: ''
            },
            {
              label: 'visible',
              default: true
            }
          ],
          value: [
            {
              material: 'material 1',
              text: '',
              image: {
                file: '',
                name: 'file_placeholder.png',
                url: 'https://bulma.io/assets/images/placeholders/800x480.png'
              },
              visible: true
            },
            {
              material: 'material 2',
              text: '',
              image: {
                file: '',
                name: 'file_placeholder.png',
                url: 'https://bulma.io/assets/images/placeholders/800x480.png'
              },
              visible: true
            }
          ]
        },
        {
          label: 'Additional Materials',
          id: 'additional_materials',
          f_component: 'VDynamicList',
          d_component: 'DynamicMaterials',
          f_bind: { hasAddButton: true },
          d_bind: { class: 'break-after' },
          template: [
            {
              label: 'image',
              component: 'VFileUpload',
              tag: 'img',
              bind: {
                hasName: true
              },
              default: {
                file: '',
                name: '',
                url: ''
              }
            },
            {
              label: 'material',
              component: 'VTextField',
              tag: 'h3',
              bind: {
                placeholder: 'Material'
              },
              default: ''
            },
            {
              label: 'text',
              component: 'VTextField',
              tag: 'p',
              bind: {
                placeholder: 'Material description',
                counter: true,
                counterValue: 160
              },
              default: ''
            },
            {
              label: 'visible',
              default: true
            }
          ],
          value: []
        },
        {
          label: 'Installation Method',
          id: 'install_method',
          f_component: 'VDynamicList',
          d_component: 'VSubsection',
          f_bind: { hasAddButton: true },
          d_bind: { class: 'break-after' },
          template: [
            {
              label: 'method',
              component: 'VTextField',
              tag: 'h3',
              bind: {
                placeholder: 'Installation method title'
              },
              default: ''
            },
            {
              label: 'text',
              component: 'VTextField',
              tag: 'p',
              bind: {
                placeholder: 'Installation method description',
                counter: true,
                counterValue: 160
              },
              default: ''
            },
            {
              label: 'image',
              component: 'VFileUpload',
              tag: 'img',
              bind: {
                hasName: true
              },
              default: {
                file: '',
                name: '',
                url: ''
              }
            },
            {
              label: 'visible',
              default: true
            }
          ],
          value: [
            {
              method: 'method 1',
              text: '',
              image: {
                file: '',
                name: 'file_placeholder.png',
                url: 'https://bulma.io/assets/images/placeholders/800x480.png'
              },
              visible: true
            }
          ]
        },
        {
          label: 'Detailed Installation Method',
          id: 'install_method_detailed',
          f_component: 'VDynamicList',
          d_component: 'VSubsection',
          f_bind: { hasAddButton: true },
          d_bind: { class: 'break-after' },
          template: [
            {
              label: 'method',
              component: 'VTextField',
              tag: 'h3',
              bind: {
                placeholder: 'Installation method title'
              },
              default: ''
            },
            {
              label: 'text',
              component: 'VTextField',
              tag: 'p',
              bind: {
                placeholder: 'Installation method description',
                counter: true,
                counterValue: 160
              },
              default: ''
            },
            {
              label: 'image',
              component: 'VFileUpload',
              tag: 'img',
              bind: {
                hasName: true
              },
              default: {
                file: '',
                name: '',
                url: ''
              }
            },
            {
              label: 'visible',
              default: true
            }
          ],
          value: []
        },
        {
          label: 'Drawing Highlights',
          id: 'drawing_highlight',
          f_component: 'VDynamicList',
          d_component: 'VSubsection',
          f_bind: {
            hasAddButton: true
          },
          template: [
            {
              label: 'elevation',
              component: 'VTextField',
              tag: 'h3',
              bind: {
                placeholder: 'Drawing highlight title'
              },
              default: 'North Elevation'
            },
            {
              label: 'text',
              component: 'VTextField',
              tag: 'p',
              bind: {
                placeholder: 'Drawing highlight description'
              },
              default: ''
            },
            {
              label: 'image',
              component: 'VFileUpload',
              tag: 'img',
              display_class: "drawing-highlight",
              bind: {
                hasName: true
              },
              default: {
                file: '',
                name: '',
                url: ''
              }
            }
          ],
          value: [
            {
              elevation: 'North Elevation',
              text: '',
              image: {
                file: '',
                name: 'file_placeholder.png',
                url: 'https://bulma.io/assets/images/placeholders/800x480.png'
              }
            },
            {
              elevation: 'South Elevation',
              text: '',
              image: {
                file: '',
                name: 'file_placeholder.png',
                url: 'https://bulma.io/assets/images/placeholders/800x480.png'
              }
            },
            {
              elevation: 'East Elevation',
              text: '',
              image: {
                file: '',
                name: 'file_placeholder.png',
                url: 'https://bulma.io/assets/images/placeholders/800x480.png'
              }
            }
          ]
        }
      ]
    },
    // {
    //   id: 'value_of_mitrex',
    //   name: 'The Value of Mitrex',
    //   type: 'dynamicSubsections',
    //   subsection_template: [
    //     {
    //       label: 'title',
    //       component: 'VTextField',
    //       tag: 'h2',
    //       bind: {
    //         placeholder: 'Subsection header'
    //       },
    //       default: ''
    //     },
    //     {
    //       label: 'text',
    //       component: 'VTextField',
    //       tag: 'p',
    //       bind: {
    //         placeholder: 'Subsection description',
    //         counter: true,
    //         counterValue: 160
    //       },
    //       default: ''
    //     },
    //     {
    //       label: 'image',
    //       component: 'VFileUpload',
    //       tag: 'img',
    //       bind: {
    //         hasName: true
    //       },
    //       default: {
    //         file: '',
    //         name: '',
    //         url: ''
    //       }
    //     }
    //   ],
    //   subsections: [
    //     {
    //       title: 'Mitrex vs. ACM/ ACP',
    //       text: '',
    //       image: {
    //         file: '',
    //         name: '',
    //         url: ''
    //       }
    //     },
    //     {
    //       title: 'Green Energy and Production Over the Year',
    //       text: '',
    //       image: {
    //         file: '',
    //         name: '',
    //         url: ''
    //       }
    //     },
    //     {
    //       title: 'Project Value Add to the Environment',
    //       text: '',
    //       image: {
    //         file: '',
    //         name: '',
    //         url: ''
    //       }
    //     }
    //   ]
    // },
    {
      id: 'pricing_summary',
      name: 'Pricing Summary',
      type: 'dynamicSubsections',
      visible: true,
      subsection_template: [
        {
          label: 'title',
          component: 'VTextField',
          tag: 'h2',
          bind: {
            placeholder: 'Pricing summary section title'
          },
          default: ''
        },
        {
          label: 'text',
          component: 'VTextField',
          tag: 'p',
          bind: {
            placeholder: 'Pricing summary section description',
            counter: true,
            counterValue: 160
          },
          default: ''
        },
        {
          label: 'image',
          component: 'VFileUpload',
          tag: 'img',
          bind: {
            hasName: true
          },
          default: {
            file: '',
            name: '',
            url: '',
          }
        }
      ],
      subsections: [
        {
          title: 'Pricing Summary 1',
          text: '',
          image: {
            file: '',
            name: '',
            url: '',
          }
        }
      ]
    },
    // {
    //   id: 'detailed_pricing',
    //   name: 'Detailed Pricing',
    //   type: 'dynamicSubsections',
    //   subsection_template: [
    //     {
    //       label: 'title',
    //       component: 'VTextField',
    //       tag: 'h2',
    //       bind: {
    //         placeholder: 'Detailed pricing section title'
    //       },
    //       default: ''
    //     },
    //     {
    //       label: 'image',
    //       component: 'VFileUpload',
    //       tag: 'img',
    //       display_class: 'detailed-pricing',
    //       bind: {
    //         hasName: true,
    //       },
    //       default: {
    //         file: '',
    //         name: '',
    //         url: ''
    //       }
    //     },
    //     {
    //       label: 'text',
    //       component: 'VTextField',
    //       tag: 'p',
    //       bind: {
    //         placeholder: 'Detailed pricing section description',
    //         counter: true,
    //         counterValue: 160
    //       },
    //       default: ''
    //     }
    //   ],
    //   subsections: []
    // },
    {
      id: 'value_vs_price',
      name: 'Value vs. Price',
      type: 'dynamicSubsections',
      visible: true,
      subsection_template: [
        {
          label: 'title',
          component: 'VTextField',
          tag: 'h2',
          bind: {
            placeholder: 'Value vs. price section title'
          },
          default: ''
        },
        {
          label: 'text',
          component: 'VTextField',
          tag: 'p',
          bind: {
            placeholder: 'Value vs. price section description',
            counter: true,
            counterValue: 160
          },
          default: ''
        },
        {
          label: 'image',
          component: 'VFileUpload',
          tag: 'img',
          bind: {
            hasName: true
          },
          default: {
            file: '',
            name: '',
            url: ''
          }
        }
      ],
      subsections: [
        {
          title: 'Value vs. Price 1',
          text: '',
          image: {
            file: '',
            name: '',
            url: ''
          }
        }
      ]
    },
    {
      id: 'general_tos',  
      name: 'Qualifications',
      type: 'static',
      visible: true,
      subsections: [
        {
          id: 'terms_purchase',
          label: 'Terms of Purchase',
          f_component: 'VRichText',
          d_component: 'VRichTextRenderer',
          value: `<ul>
                    <li>This offer is valid for <mark>30 days.</mark></li>
                    <li>This agreement shall be concluded upon the execution of an agreement to formalize the type and quantity of products requested.</li>
                    <li>
                      This offer is made with the understanding that a pre-award meeting will include a design review and mutual acceptance of the scope of work, contract documents, schedule and terms and conditions prior to finalizing an agreement.
                      <ul>
                        <li>An agreement to be concluded between Mitrex and the customer at the earliest of issuing an order confirmation by Mitrex.</li>
                      </ul>
                    </li>
                    <li>Any changes from the plans or specifications involving additional costs shall be executed only upon signed written change orders and will be an extra charge over and above the price of this proposal on an item-by-item basis or completed on a time and material basis.</li>
                    <li>Holdback to be released 45 days after substantial completion of panel installation as per completed area.</li>
                    <li>Holdback to be released 45 days after substantial completion of the production phase.</li>
                    <li>30% Deposit payment is required. No project shall commence until the deposit has been made and contract has been confirmed.</li>
                    <li>Payments to Mitrex are not contingent upon the Contractor or Owner being paid by Owner and/or Lender. No contingency of paying will be acceptable.</li>
                    <li>Price based on non-union labour.</li>
                    <li>No return, exchange or refund policy applies to all custom-made products.</li>
                    <li>Proposal is based on Sq.Ft/ Lft area, any addition on the estimated area will result in price being re-estimated.</li>
                    <li>All estimates are subject to site delivery and the final invoice is based on total delivered products.</li>
                    <li>All delivered products are the property of Mitrex Inc. until fully paid by the customer.</li>
                    <li>The price stated in the order shall be the base price for the products and does not include value added taxes. And all amounts to be paid in full and without any deduction.</li>
                    <li>Unless otherwise agreed in writing, any invoice shall be due and payable within 30 calendar days of the date of such invoice.</li>
                    <li>2% per month (24% per annum) charged on overdue accounts, this rate will apply both before and after any adjustment that may be obtained for a nonpayment.</li>
                    <li>Mitrex Inc. can exercise the right to cancel the production slot or all previously agreed upon timelines due to nonpayment/late payments. When payment is received, it is at the discretion of Mitrex Inc. to provide a revised delivery timeline. Mitrex Inc. is not responsible for any project delays or issues as a result of nonpayment/late payment.</li>
                    <li>Mitrex Inc. can exercise the right to move produced products to a third party storage facility in the event of nonpayments/late payments. Mitrex Inc. can charge $85 per day, per skid, A-frame or L-frame, and an additional $1,000 of logistics costs until payment is cleared.</li>
                    <li>Mitrex Inc. can exercise the right to demobilize the installation team due to nonpayment/late payments of over 30 days in the installation phase. Mitrex Inc. can charge the cost of demobilization to the customer, at a flat rate of $15,000. The project timeline will then be renegotiated according to the delays as a result of nonpayment/late payments.</li>
                    <li>Cost of any bonding (performance and labor/material payment bonds and other insurances) is excluded.</li>
                    <li>No liquidated or consequential damages.</li>
                    <li>No waivers of Subrogation or Severability of Interest clauses.</li>
                    <li>Upon acceptance, this quotation is or becomes part of the legal contract documents.</li>
                    <li>All extra contract hours performed must be signed off by an authorized Owner Representative.</li>
                    <li>All approved extra to contract time and material charges will be billed on the next billing.</li>
                    <li>The total price for supply of products and related services shall be subject to taxes and any change orders/extras.</li>
                    {PAYMENT_INSTRUCTION_INSTALL}
                  </ul>`
        },
        {
          id: 'terms_delivery',
          label: 'Delivery Terms',
          f_component: 'VRichText',
          d_component: 'VRichTextRenderer',
          value: `<ul>
                    <li>This proposal is based on a <mark>Q1 2023</mark> production date.</li>
                    <li>Schedule of work and manufacturing schedule to be mutually agreed upon by the Client and Mitrex Inc.</li>
                    <li>In the event that the construction schedule is delayed by no fault of the Subcontractor, the Subcontractor will incur storage costs relating to product built in accordance with the construction schedule. Such costs will be billed back to the Owner in the form of a change order.</li>
                    <li>Mitrex Inc. will not be responsible for delays in delivery, installation, or any related services due to any unforeseen impediments beyond its control, such as disruptive weather, Acts of Gods, strikes, boycotts, lockouts, fires, war, pandemics, embargos, or manufacturing and operational delays.</li>
                    <li>Shop drawing submission date to be agreed to prior to award. Complete issued for construction CAD drawings is required prior to commencement.</li>
                    <li>Shop drawings and other related documents to be submitted in English.</li>
                    <li>Schedule will be weather permitting and no penalties for slow previous trades.</li>
                    <li>First delivery of products will be on site the greater of <mark>20-24</mark> weeks after final approval of shop drawings or mutually agreed upon schedule.</li>
                    <li>The Products will be delivered by Mitrex to the customer to the location indicated in the Purchase Order. Mitrex reserves the right to schedule the delivery of any order it accepts from the customer, and Mitrex reserves the right to reschedule at its discretion. Advance notice shall be provided to the customer if there are any changes to the scheduled delivery date.</li>
                    <li>Mitrex will require unfettered use of the customer's onsite power and/or utilities for tools and equipment for installations, repairs, replacements, or any other related services pursuant to the supply and installation agreement.</li>
                    <li>Mitrex requires a dedicated, fenced, and protected area for material storage on site.</li>
                  </ul>`
        },
        {
          id: 'acceptable_tolerances',
          label: 'Acceptable Tolerances/ System Requirements',
          f_component: 'VRichText',
          d_component: 'VRichTextRenderer',
          value: `<strong>Solar Cladding</strong>
                  <ul>
                    <li>Overall R-values, condensation values, and all other performance criteria to be determined by final design. At this point, Mitrex has not considered thermal and structural requirements that can affect the pricing.</li>
                    <li>Due to material limitations, some panels/details may require added joints and/or detail modifications. Re-design of some details required.</li>
                    <li>Quoted system to follow Mitrex standard detailing, depth system requirements, specifications and product fabrication procedures. System details available on request.</li>
                    <li>We cannot guarantee visual flatness of Mitrex panels. Visual flatness under all conditions is a subjective measure. Mitrex panels shall be fabricated in a workmanlike manner to provide maximum deviation from flat of 1/8" based on L/240. Acceptance/rejection shall be based on objective measurements, not subjective visual observations.</li>
                    <li>System joints including panel to panel, vertical and horizontal, and panel to panel alignment tolerance +-¼".  Mitrex panel to other materials +-1/2". Mitrex panel to windows/doors and other penetrations +-1-1/2".</li>
                    <li>Elastic deflection limits for panels to be L/240 + ¼" for spans greater than 40".</li>
                    <li>Standard sheet size of Mitrex panels is 39" x 79". Any panels exceeding these limits will be considered custom panels.</li>
                    <li>Custom panel sizes can be considered during Mitrex panel layout proposal phase.</li>
                    <li>Proper structure is required at all anchoring locations.</li>
                    <li>Products except where otherwise noted will be furnished according to MRTS (Mitrex Technical Specification).</li>
                    <li>Mitrex panels are subject to variations in color, markings and texture. Color variations, veining, shadings, marking are inevitable.</li>
                    <li>Any samples are approximations only. Samples to be agreed by both parties prior to order.</li>
                    <li>Imperfections are to be corrected using Mitrex Technical Specification (MRTS).</li>
                    <li>Wall substrate to be plumb, true and acceptable to standard construction tolerances prior to installation of exterior wall panels.</li>
                    <li>Extra cost may apply for excessive wall adjustments. Acceptable existing substrate tolerances for Mitrex system is maximum ⅜".</li>
                    <li>All thermal performance requirements are based on average project sizes.</li>
                    <li>All columns and shear walls must be a minimum within acceptable tolerances +- ⅜" every 120", true, level and plumb.</li>
                    <li>All penetrations made by others through the air/vapour barrier are the responsibility of others to seal.</li>
                    <li>We are not responsible for components of other scopes that may be deemed "Climbable". It is the architect's responsibility to flag any components that may be deemed "Climbable". All remedies on site to accommodate anti-climbing will be charged extra to the contract.</li>
                    <li>All products will conform to building codes.</li>
                    <li>Preparation for low voltage wiring included only if locations are provided prior to manufacturing and installation.</li>
                  </ul>
                  <strong>Solar Railing</strong>
                  <ul>
                    <li>Due to material limitations, some products/details may require detail modifications. Re-design of some details required.</li>
                    <li>Quoted system to follow Mitrex standard detailing, depth system requirements, specifications and product fabrication procedures. System details available on request.</li>
                    <li>We cannot guarantee visual flatness of Mitrex products. Visual flatness under all conditions is a subjective measure. Mitrex products shall be fabricated in a workmanlike manner to provide maximum deviation from flat of 1/8" based on L/240. Acceptance/rejection shall be based on objective measurements, not subjective visual observations.</li>
                    <li>System joints including panel to panel, vertical and horizontal, and panel to panel alignment tolerance +-¼".  Mitrex panel to other materials +-1/2". Mitrex panel to windows/doors and other penetrations +-1-1/2".</li>
                    <li>Elastic deflection limits for products to be L/240 + ¼" for spans greater than 40".</li>
                    <li>Standard sheet size of Mitrex products is dependent on the system. </li>
                    <li>Custom sizes can be considered during Mitrex panel layout proposal phase.</li>
                    <li>Proper structure is required at all anchoring locations.</li>
                    <li>Products except where otherwise noted will be furnished according to MRTS (Mitrex Technical Specification).</li>
                    <li>Mitrex products are subject to variations in color, markings and texture. Color variations, veining, shadings, marking are inevitable.</li>
                    <li>Any samples are approximations only. Samples to be agreed by both parties prior to order.</li>
                    <li>Imperfections are to be corrected using Mitrex Technical Specification (MRTS).</li>
                    <li>Wall and slab substrate to be plumb, true and acceptable to standard construction tolerances prior to installation of products.</li>
                    <li>Extra cost may apply for excessive adjustments. Acceptable existing substrate tolerances for Mitrex system is maximum ⅜".</li>
                    <li>All penetrations made by others through the air/vapour barrier are the responsibility of others to seal.</li>
                    <li>We are not responsible for components of other scopes that may be deemed "Climbable". It is the architect's responsibility to flag any components that may be deemed "Climbable". All remedies on site to accommodate anti-climbing will be charged extra to the contract.</li>
                    <li>All products will conform to building codes.</li>
                    <li>Preparation for wiring included only if locations are provided prior to manufacturing and installation.                  </li>
                  </ul>`
        },
        {
          id: 'warranty',
          label: 'Warranty',
          f_component: 'VRichText',
          d_component: 'VRichTextRenderer',
          value: `<ul>
                    <li>The returns, refunds, and replacement of Products are covered under Mitrex standard 25-year Limited Product Warranty and 25-year Limited Performance Warranty, along with the process of claiming said returns, refunds and replacement. Said warranties are provided upon the execution of the supply and installation agreement. </li>
                    <li><mark>2-year labour warranty</mark>.</li>
                    <li>Upon product arrival, it's up to the customer to inspect their condition, nature and their compliance with the order and inform Mitrex of any compliance in writing within 3 days of receipt of the products. Mitrex warrants to re-supply such defective material only as brought to their attention; material placed on the wall shall constitute product acceptance.</li>
                    <li>Extended and other special warranties are excluded.</li>
                    <li>Products will be replaced during the course of construction if it is determined to be a cause of faulty manufacturing. In the case it is broken due to other circumstances, the owner will pay to replace the affected panels and components.</li>
                  </ul>`
        },
        {
          id: 'miscellaneous',
          label: 'Miscellaneous',
          f_component: 'VRichText',
          d_component: 'VRichTextRenderer',
          value: `<ul>
                    <li>Any drawing, catalogue or technical literature sent to the customer before and after termination of order remains Mitrex Inc. exclusive property and cannot be copied, reproduced, transmitted or notified to third parties without prior consent in writing from Mitrex, as strictly confidential.</li>
                    <li>Our proposal is based on the responsibility for the protection of our material after acceptance to be borne by the owner and/or General Contractor.</li>
                  </ul>`
        }
      ]
    },
    {
      id: 'tax_incentives_breakdown',  
      name: 'Cost and Benefit Breakdown',
      type: 'optional',
      visible: false,
      component: 'TaxIncentivesCostBreakdown',
      bind: {
        costBreakdownOne: '',
        costBreakdownTwo: ''
      },
      inputs: [
        {
          bind: {
            placeholder: 'Cost Breakdown Description (1)',
            rows: 3
          },
          component: 'VTextArea',
          bind_field: 'costBreakdownOne'
        },
        {
          bind: {
            placeholder: 'Cost Breakdown Description (2)',
            rows: 3
          },
          component: 'VTextArea',
          bind_field: 'costBreakdownTwo'
        }
      ]
    },
    {
      id: 'tax_incentives_summary',  
      name: 'Summary of Possible Tax Incentives',
      type: 'optional',
      visible: false,
      component: 'TaxIncentivesSummary',
      bind: {
        taxIncentiveDesc: `The Accelerated Capital Cost Allowance (CCA) for Class 43.1 and Class 43.2 and the First-Year Enhanced CCA tax incentives are available for clean energy, including solar energy, equipment that is integrated into a building used for the purpose of earning income in Canada. Photovoltaic equipment used primarily for generating electrical energy as well as electrical energy storage equipment qualify for CCA under Class 43.1 or Class 43.2. For more information, see sections 2.7 and 2.19 of Canada’s Technical Guide to Class 43.1 and 43.2.`,
        summaryTaxIncentiveDesc: `Eligible equipment for class 43.1 or class 43.2 that is acquired after November 20, 2018 and is available for use before 2024 can qualify for 100% CCA in the first year it becomes available for use. There is no restriction on CCA claim under half-year rule in this case.`
      },
      inputs: [
        {
          bind: {
            placeholder: 'Tax Incentives Description',
            rows: 3
          },
          component: 'VTextArea',
          bind_field: 'taxIncentiveDesc'
        },
        {
          bind: {
            placeholder: 'Summary Tax Incentives Description',
            rows: 3
          },
          component: 'VTextArea',
          bind_field: 'summaryTaxIncentiveDesc'
        }
      ]
    },
    {
      id: 'r_value_savings',  
      name: 'The Mitrex System and Energy Savings',
      type: 'optional',
      visible: false,
      component: 'RetrofitSavings',
      bind: {
        desc: 'For all retrofit projects, Mitrex can attain any R-value needed for the building. The R-value measures how well a barrier resists the flow of heat caused by conduction. The Mitrex cladding system can increase the R-value of the building envelope and has a significant contribution in retaining the heat that would otherwise be lost with a less efficient system. The value of this is immense for retrofit projects since a large amount of heat is lost due to poor insulation before retrofitting. Not only can Mitrex solar cladding provide electricity generation, but it will also reduce the loss of energy and act as an energy-efficient building envelope, and passively helping the building owners to save money. Please Note: The above calculations are designed to provide an approximation of potential savings. Actual savings can vary due to many factors and variables.'
      },
      inputs: [
        {
          bind: {
            placeholder: 'Mitrex System Savings Desc',
            rows: 3
          },
          component: 'VTextArea',
          bind_field: 'desc'
        }
      ]
    },
    {
      id: 'environmental_impact',  
      name: 'Environmental Impact',
      type: 'optional',
      visible: true,
      component: 'EnvironmentalImpact'
    },
    {
      id: 'batt_and_inverter',  
      name: 'Battery and Inverter',
      type: 'optional',
      visible: true,
      component: 'BatteryAndInverter'
    },
    {
      id: 'value_of_mitrex',  
      name: 'Value of Mitrex',
      type: 'optional',
      visible: true,
      component: 'ValueOfMitrex'
    },
    {
      id: 'cladding_and_installation',  
      name: 'Cladding and Installation',
      type: 'optional',
      visible: true,
      component: 'AboutCladify'
    },
    {
      id: 'sample_swatches',  
      name: 'Sample Swatches',
      type: 'optional',
      visible: true,
      component: 'SampleSwatchesMitrex'
    },
    {
      id: 'past_projects_one',  
      name: 'Past Projects (1)',
      type: 'optional',
      visible: true,
      component: 'PastProjectsOne'
    },
    {
      id: 'past_projects_two',  
      name: 'Past Projects (2)',
      type: 'optional',
      visible: true,
      component: 'PastProjectsTwo'
    },
    {
      id: 'past_projects_three',  
      name: 'Past Projects (3)',
      type: 'optional',
      visible: true,
      component: 'PastProjectsThree'
    },
    {
      id: 'last_page',  
      name: 'Last Page',
      type: 'optional',
      visible: true,
      component: 'LastPage',
      bind: {
        productBrand: 'Mitrex'
      }
    }
  ]
}
